/**
 * デフォルトのモジュールを読込
 */
import './Default';

/**
 * コンポーネント
 */
import { GlobalNavModule } from './components/globalNav/globalNav';
const $globalNavModule = new GlobalNavModule.Service();

import { KeenSliderModule } from './components/keen-slider/keen-slider';
const $keenSliderModule = new KeenSliderModule.Service();

import { WysiwygTableWrapModule } from './components/wysiwygTableWrap/wysiwygTableWrap';
const $wysiwygTableWrapModule = new WysiwygTableWrapModule.Service();
